<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <v-card-text>
        <span
          v-if='!estimate.estimate_detail.fertilizer_field_instructions'
          :class='estimate.estimate_detail.fertilizer ? "" : "font-italic text--disabled font-weight-thin"'
        >
          {{ estimate.estimate_detail.fertilizer ? 'None...' : '(Fertilizer not selected)'}}
        </span>
        <span v-html='estimate.estimate_detail.fertilizer_field_instructions'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        outlined
        auto-grow
        v-model='detailCopy.fertilizer_field_instructions'
        hint='this will only appear on fertilizer/weed control work orders'
        persistent-hint
      ></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'fertilizer-field-instructions',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Fertilizer Field Instructions',
    icon: 'mdi-sprout',
    iconColor: 'success',
    detailCopy: [],
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.detailCopy = _.cloneDeep(this.estimate.estimate_detail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.detailCopy)
      this.showDialog = false
    }
  }
}
</script>